import { Dispatch } from "redux";
import api from "../../api/api";

import {
  setArchiveCourseList,
  setloading,
  seterror,
  setPagination,
  resetCourseList,
} from "../reducers/getAllArchivedCoursesReducer";

const getAllArchivedCoursesAction =
  (
    page,
    id,
    token,
    search,
    sort
  ) =>
  async (dispatch: Dispatch) => {
    dispatch(setloading(true));

    try {
      const result = await api.get(
        `/courses/archived/`,
        {
          params: {
            page,
            search,
            sort,
          },

          headers: {
            "Content-Type":
              "application/json",
            Authorization: `Token ${token}`,
          },
        }
      );

      if (result?.status === 200) {
        dispatch(
          setArchiveCourseList(
            result.data.data
          )
        );

        dispatch(
          setPagination({
            count: result.data.count,
            next: result.data.next,
            previous: result.data.previous,
            current_page: page,
            totalPages: Math.ceil(result.data.count / 12),
          }),
        );
      } else {
        dispatch(
          seterror(
            result.data?.message ||
              "Something Went Wrong!"
          )
        );
      }
    } catch (error) {
      dispatch(
        seterror("Something Went Wrong!")
      );
    } finally {
      dispatch(setloading(false));
    }
  };

export {
  getAllArchivedCoursesAction,
  resetCourseList,
};